import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { Dispatch } from "redux"
import { invalidateTransactions } from "~Shared/queries/transaction.queries"
import { setShouldFetchCashFlowsData } from "~Shared/store/actions/liquidity/liquidityActions"
import { refetchTable } from "~Shared/store/actions/tables/tableActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToTransactions = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        switch (operationType) {
            case OperationTypeEnum.INSERT:
            case OperationTypeEnum.DELETE:
            case OperationTypeEnum.BULK_UPDATE:
            case OperationTypeEnum.UPDATE:
                dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
                dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
                dispatch(refetchTable(TablesEnum.TRANSACTIONS_ALL))
                dispatch(refetchTable(TablesEnum.EXPENSE_TRANSACTIONS))
                dispatch(refetchTable(TablesEnum.CARD_TRANSACTIONS))
                void invalidateTransactions()
                break
            case OperationTypeEnum.TRANSACTION_UPDATE_CATEGORY:
                setShouldFetchCashFlowsData(true)(dispatch)
                dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
                dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
                dispatch(refetchTable(TablesEnum.TRANSACTIONS_ALL))
                break
            default:
                break
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Transaction Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}

export const subscribeToTransactionsCallbacks = (dispatch: Dispatch<any>, { fullDocument: { operationType } }: DocumentChangeInterface) => {
    switch (operationType) {
        case OperationTypeEnum.BULK_UPDATE:
        case OperationTypeEnum.BULK_INSERT:
            // Required to update transaction view when a category has been successful deleted when checkAndNotify returns false
            // Perform sync to the transactions
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
            dispatch(refetchTable(TablesEnum.TRANSACTIONS_ALL))
            void invalidateTransactions()
            break
        default:
            break
    }
}
